import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

function ConnectSSO() {
  const {
    RelayState,
    SAMLResponse,
    destination_url: destinationURL,
  } = useSelector(store => store.iframe);

  useEffect(() => {
    const ssoHasRun = sessionStorage.getItem('ssoHasRun');
    if (!ssoHasRun && RelayState && SAMLResponse && destinationURL) {
      console.log('submitting SAML auth...');
      sessionStorage.setItem('ssoHasRun', 'true');
      // document.forms.auto_submit.submit();
      setTimeout(() => {
        sessionStorage.setItem('ssoHasRun', '');
      }, 20000);
    }
  }, [RelayState, SAMLResponse, destinationURL]);


  return (
    <div>
      <p>
        RelayState: {RelayState}
      </p>
      <br />
      <p>
        SAMLResponse: {SAMLResponse}
      </p>
      <br />
      <p>
        destination_url: {destinationURL}
      </p>
      <form action={destinationURL} name="auto_submit">
        <input type="hidden" name="RelayState" value={RelayState} />
        <input type="hidden" name="SAMLResponse" value={SAMLResponse} />
        <input type="submit" value="submit" />
      </form>
    </div>
  );
}

export default ConnectSSO;
